// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Gz-z","smallCardRow":"Hz-z","largeCardRow":"Iz-z","productSearchRow":"Jz-z","curatedRow":"Kz-z"};